<script setup>
const props = defineProps({ blok: Object })
const { locale } = useI18n()
const story = await useAsyncStoryblok('components/content/map', { version: 'publish', language: locale.value })
const resolvedRichText = computed(() => renderRichText(props.blok.content))

const paddingClasses = computed(() => {
  switch (props.blok.padding) {
    case 'padding-top':
      return 'pt-mobile lg:pt-desktop'
    case 'padding-both':
      return 'py-mobile lg:py-desktop'
    default :
      return 'pb-mobile lg:pb-desktop'
  }
})
</script>

<template>
  <div :class="paddingClasses">
    <div class="container">
      <div
        class="mb-1 text-center text-md text-secondary-red-100 font-bold capitalize lg:text-xl md:text-xl sm:text-lg"
      >
        <span v-if="blok.header">{{ blok.header }}</span>
        <span v-else>{{ story.content.header }}</span>
      </div>
      <h2 class="mx-auto mb-custom-md text-center text-3xl font-bold lg:max-w-2xl md:max-w-xl md:text-4xl xl:text-5xl">
        <span v-if="blok.title">{{ blok.title }}</span>
        <span v-else>{{ story.content.title }}</span>
      </h2>
      <div v-if="resolvedRichText" class="article mx-auto max-w-6xl text-center" v-html="resolvedRichText" />
      <Location class="relative z-1 mb-custom-2xl mt-custom-2xl" />
      <UIMap class="-translate-y-20" />
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>
